import { Link } from "react-router-dom";
import { checkIcon } from "../../../assets/icons";
import styles from "./newAdFinal.module.css";
import { useContext, useEffect, useRef } from "react";
import { WizardContext } from "../../../Store/Wizard.store";
export default function NewAdFinal() {
    const {wizardFormData, setWizardFormData} = useContext(WizardContext);
    const h2Ref = useRef<HTMLHeadingElement>(null);

    useEffect(() => {
        if (h2Ref.current) {
            h2Ref.current.scrollIntoView();
        }
    }, []);

    const clearData = () => {
        setWizardFormData({
            wizardStep: 1,
            initialSetup: true,
            alternativeFilter: [],
            editMode: false,
            adData: {
                id: 0,
                title: "",
                description: "",
                alternativeToCategories: [],
                supplementaryInformation: "",
                useCategories: [],
                sectorCategories: [],
                certificationCategories: [],
                isBioBased: false,
                casNumber: "",
                technicalDataSheet: undefined,
                safetyDataSheet: undefined,
                additionalDocuments: undefined,
                additionalInformation: "",
                companyName: "",
                companyGroupId: 0,
                companyWebsite: "",
                contactName: "",
                contactEmail: "",
                logotype: {
                    fileData: new File([""], ""),
                    fileName: "",
                    mimeType: "",
                    id: 0,
                },
                alternativeLevel: 0
            },
        })
    }

    return (
        <div ref={h2Ref} className={styles.start}>
            <div className={styles.check}>
                {checkIcon}
            </div>
            {wizardFormData.editMode ? <h2>Your ad is updated!</h2> : <h2>Your ad is submitted!</h2>}
            <p>Thank you for submitting your advertisement to Chemsec Marketplace!
            Our team will now review your ad. We will notify you by e-mail once your ad is live on the marketplace.</p>
            <div className={styles.button_container}>
                <Link to="/search" className="button_inverted button">Discover alternatives</Link>
                <button onClick={clearData} className="button button_black">Create a new ad</button>
            </div>
        </div>
    )
}